var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgMaintenance = function SvgMaintenance(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 80,
    height: 80,
    ref: ref
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 57,
    height: 19,
    x: 12,
    y: 19,
    fill: "#FFC8B2",
    rx: 9.5,
    transform: "rotate(-90 40.5 28.5)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 40.496,
    cy: 70.496,
    fill: "#FF9265",
    rx: 9.563,
    ry: 9.524,
    transform: "rotate(-45 40.496 70.496)"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgMaintenance);
export { ForwardRef as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI4MCIgaGVpZ2h0PSI4MCI+PGcgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj48cmVjdCB3aWR0aD0iNTciIGhlaWdodD0iMTkiIHg9IjEyIiB5PSIxOSIgZmlsbD0iI0ZGQzhCMiIgcng9IjkuNSIgdHJhbnNmb3JtPSJyb3RhdGUoLTkwIDQwLjUgMjguNSkiLz48ZWxsaXBzZSBjeD0iNDAuNDk2IiBjeT0iNzAuNDk2IiBmaWxsPSIjRkY5MjY1IiByeD0iOS41NjMiIHJ5PSI5LjUyNCIgdHJhbnNmb3JtPSJyb3RhdGUoLTQ1IDQwLjQ5NiA3MC40OTYpIi8+PC9nPjwvc3ZnPg==";